"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlDialog = void 0;
var React = require("react");
var mobx_react_1 = require("mobx-react");
var dialog_1 = require("../dialog");
var contexts_1 = require("../../interfaces/contexts");
var App_1 = require("../../App");
var controlFormTabs_1 = require("./controlFormTabs");
var categoryTagList_1 = require("./categoryTagList");
var typestyle_1 = require("typestyle");
var generic_1 = require("../generic");
var buttons_1 = require("../buttons");
var iterUtils_1 = require("../lib/iterUtils");
var ControlDialog = (function (_super) {
    __extends(ControlDialog, _super);
    function ControlDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.changed = false;
        _this.comments_changed = false;
        _this.closeHandler = function () {
            _this.props.onClose ? _this.props.onClose() : App_1.store.controlDialog.closeDialog();
            if (App_1.store.controlDialog.refreshAfterClose) {
                App_1.store.controlDialog.refreshAfterClose = false;
                window.location.reload();
            }
        };
        _this.state = _this.getStateFromProps(props);
        return _this;
    }
    ControlDialog.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.control != this.props.control ||
            nextProps.applied_tags != this.props.applied_tags) {
            this.setState(this.getStateFromProps(nextProps));
        }
    };
    ControlDialog.prototype.getStateFromProps = function (props) {
        var context = App_1.store.context.get();
        if (context instanceof contexts_1.ProjectContext) {
            var controlPut = props.control ? {
                id: props.control.id,
                project: props.control.project,
                status: props.control.status,
                description: props.control.description,
                deadline: props.control.deadline,
                assigned_to: props.control.assigned_to,
                udf_values: props.control.udf_values
            } : {
                id: null,
                project: context.project,
                status: 10,
                description: '',
                deadline: null,
                assigned_to: null,
                udf_values: null
            };
            return {
                controlPut: controlPut,
                selectedTags: props.applied_tags,
                updating: false,
            };
        }
        else {
            throw new Error("ControlDialog does not support the current context");
        }
    };
    ControlDialog.prototype._submit = function (controlPut, close_dialog) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                App_1.store.controlDialog.saveControlInformation(controlPut).then(function (result) {
                    if (result) {
                        if (close_dialog) {
                            App_1.store.controlDialog.closeDialog();
                        }
                        _this.props.onSubmit && _this.props.onSubmit();
                        if (App_1.store.controlDialog.refreshAfterClose) {
                            App_1.store.controlDialog.refreshAfterClose = false;
                        }
                    }
                });
                return [2];
            });
        });
    };
    ControlDialog.prototype.submit = function (e, close_dialog) {
        var _this = this;
        if (close_dialog === void 0) { close_dialog = false; }
        var mandatory_is_checked = true;
        var exclusive_is_checked = true;
        var mandatory_categories = this.props.available_tags.map(function (tag) {
            if (tag.category_mandatory) {
                return tag.category;
            }
        });
        var exclusive_categories = this.props.available_tags.map(function (tag) {
            if (tag.category_exclusive) {
                return tag.category;
            }
        });
        var applied_categories = this.state.selectedTags.map(function (tag) {
            return tag.category;
        });
        mandatory_categories.forEach(function (category) {
            if (typeof (category) == "number") {
                if (!(0, iterUtils_1.contains)(applied_categories, category)) {
                    mandatory_is_checked = false;
                    return;
                }
                else {
                    mandatory_is_checked = true;
                }
            }
        });
        function getOccurrence(array, value) {
            return array.filter(function (v) { return (v === value); }).length;
        }
        exclusive_categories.forEach(function (category) {
            if (getOccurrence(applied_categories, category) > 1) {
                exclusive_is_checked = false;
                return;
            }
            else {
                exclusive_is_checked = true;
            }
        });
        if (!mandatory_is_checked) {
            notification(gettext("You must check at least one tag from each mandatory category."), { type: "error" });
            event.stopImmediatePropagation();
        }
        if (!exclusive_is_checked) {
            notification(gettext("You cannot select more than one tag for mutually exclusive categories."), { type: "error" });
            event.stopImmediatePropagation();
        }
        if (mandatory_is_checked && exclusive_is_checked) {
            this.setState({
                updating: true
            });
            this.state.controlPut.tags = this.state.selectedTags.map(function (tag) { return tag.id; });
            this._submit(this.state.controlPut, close_dialog).then(function () {
                _this.setState({ updating: false });
            }, function () {
                _this.setState({ updating: false });
            });
        }
    };
    ControlDialog.prototype.submitAndClose = function (e) {
        this.submit(e, true);
    };
    ControlDialog.prototype._submitRecurrence = function (control, recurrence) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(control.deadline !== this.props.control.deadline)) return [3, 2];
                        control.tags = this.state.selectedTags.map(function (tag) { return tag.id; });
                        return [4, App_1.store.controlDialog.saveControlInformation(control)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4, App_1.store.controlDialog.saveControlRecurrence(recurrence)];
                    case 3:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    ControlDialog.prototype.submitRecurrence = function (control, recurrence) {
        this._submitRecurrence(control, recurrence);
    };
    ControlDialog.prototype.onControlInformationChange = function (name, value) {
        this.changed = true;
        var controlPut = this.state.controlPut;
        controlPut[name] = value;
        this.setState({
            controlPut: controlPut
        });
    };
    ControlDialog.prototype.onCategoryTagChange = function (tag, e) {
        this.changed = true;
        var selectedTags = this.state.selectedTags;
        if (e) {
            selectedTags.push(tag);
            if (tag.category_exclusive) {
                selectedTags.map(function (object, index) {
                    if (tag.category === object.category && tag.name !== object.name) {
                        selectedTags.splice(index, 1);
                    }
                });
            }
            this.setState({ selectedTags: selectedTags });
        }
        else {
            var index = selectedTags.map(function (tag) { return tag.id; }).indexOf(tag.id);
            if (index >= 0) {
                selectedTags.splice(index, 1);
                this.setState({ selectedTags: selectedTags });
            }
        }
    };
    ControlDialog.prototype.onNoSelection = function (e) {
        var category_name = e.currentTarget.name;
        var selectedTags = this.state.selectedTags;
        selectedTags.map(function (object, index) {
            if (object.category_name === category_name) {
                selectedTags.splice(index, 1);
            }
        });
    };
    ControlDialog.prototype.render = function () {
        var _this = this;
        var self = this;
        var props = this.props;
        var state = this.state;
        var description = props.control && props.control.description || "";
        var contentLabel = (props.control ?
            get_term("Control") + " #".concat(props.control.control_number, ": ").concat(description) :
            get_term("New Control"));
        var isAdding = props.control ? '' : 'ControlDialog--adding-control';
        return (React.createElement(dialog_1.Dialog, { isOpen: props.isOpen, isReady: true, contentLabel: contentLabel, shouldCloseOnOverlayClick: true, onClose: function () {
                if (_this.changed || _this.comments_changed) {
                    fancyConfirm(gettext("You have unsaved changes. Are you sure you want to discard them?"), function () {
                        _this.changed = false;
                        _this.closeHandler();
                    });
                }
                else {
                    _this.changed = false;
                    _this.closeHandler();
                }
            }, forcedWidth: "950px" },
            React.createElement("div", { className: (0, typestyle_1.classes)("ControlDialog", isAdding) },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-3" },
                        React.createElement("div", { className: "CategoryTagList" },
                            React.createElement("h3", null,
                                gettext("Tags"),
                                props.isMandatoryCA &&
                                    React.createElement(buttons_1.ActionButton, { className: "pl-1 pr-0", onClick: function () {
                                            notification(gettext("You have missing selections for mandatory tags"), { type: "warning" });
                                        } },
                                        React.createElement(generic_1.Icon, { className: "asterisk", name: generic_1.Icons.exclamation })),
                                props.isExclusiveCA &&
                                    React.createElement(buttons_1.ActionButton, { className: "pl-1 pr-0", onClick: function () {
                                            notification(gettext("Mutually exclusive category has more than one tag selected."), { type: "warning" });
                                        } },
                                        React.createElement(generic_1.Icon, { className: "asterisk", name: generic_1.Icons.exclamation })))),
                        React.createElement(categoryTagList_1.CategoryTagList, { applied_tags: state.selectedTags, available_tags: props.available_tags, editable: props.control === null, onChange: this.onCategoryTagChange.bind(this), onNoSelection: this.onNoSelection.bind(this) })),
                    React.createElement("div", { className: "col" },
                        React.createElement(controlFormTabs_1.ControlFormTabs, { control: props.control, controlPut: state.controlPut, recurrence: props.recurrence, comments: props.comments, relations: props.relations, causality_relations: props.causality_relations, references: props.references, entries: props.entries, availableStatuses: props.availableStatuses, availableOwners: props.availableOwners, availableRecurrence: props.availableRecurrence, controlCosts: props.controlCosts, availableRiskTargets: props.availableRiskTargets, udf_types: props.udf_types, udf_section_header: props.udf_section_header, onChange: this.onControlInformationChange.bind(this), onCommentChange: function () { self.comments_changed = true; }, onCommentSubmit: function (comment) {
                                var values = {
                                    comment: comment
                                };
                                App_1.store.controlDialog.postComment(values);
                                self.comments_changed = false;
                            }, updating: this.state.updating, handleControlInformationSubmit: this.submit.bind(this), handleControlInformationSubmitAndClose: this.submitAndClose.bind(this), handleRecurrenceSubmit: this.submitRecurrence.bind(this) }))))));
    };
    ControlDialog = __decorate([
        mobx_react_1.observer
    ], ControlDialog);
    return ControlDialog;
}(React.Component));
exports.ControlDialog = ControlDialog;
